// extracted by css-extract-rspack-plugin
export default {"cls1":"SplitVerdictPreviewList-cls1_wkv","cls2":"SplitVerdictPreviewList-cls2_Dgy SplitVerdictPreviewList-cls1_wkv"};